import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemDismiss from "components/BulkActions/Drawer/Item/Dismiss";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsActionDescriptor,
  BulkActionsStep,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import useAnalytics from "hooks/useAnalytics";
import { ActionAvailabilityBanner } from "components/BulkActions/Drawer/Item/ActionAvailabiltyBanner";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import SpacePath from "components/SpacePath";
import Typography from "ds/components/Typography";

import { IdpGroupRolesBulkActions } from "./types";
import { RoleBinding } from "../types";

type IdpGroupRolesBulkActionsSelectedItemPropsBase = {
  item: RoleBinding;
  onDismiss: (id: BulkActionItemID) => void;
};

type IdpGroupRolesBulkActionsSelectedItemProps = IdpGroupRolesBulkActionsSelectedItemPropsBase &
  (
    | {
        step: BulkActionsStep.ActionConfirmation;
        itemCategory: BulkActionActionConfirmationTabs;
        itemActions?: never;
        allActionsQty?: never;
      }
    | {
        step: BulkActionsStep.ChooseAction;
        itemActions: BulkActionsActionDescriptor<IdpGroupRolesBulkActions>[] | undefined;
        allActionsQty: number;
        itemCategory?: never;
      }
  );

const IdpGroupRolesBulkActionsSelectedItem = ({
  item,
  itemActions,
  onDismiss,
  allActionsQty,
  step,
  itemCategory,
}: IdpGroupRolesBulkActionsSelectedItemProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageOrganization.OrganizationIdpGroupRoles,
  });

  const handleDismiss = () => {
    onDismiss(item.id);
    trackSegmentAnalyticsEvent("Bulk Actions - Drawer - Item dismissed");
  };

  const isChooseActionStep = step === BulkActionsStep.ChooseAction;
  const actionTexts = (itemActions || []).map((action) => action.title);

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box gap="medium" align="start" justify="between" fullWidth zeroMinWidth={false}>
        <Box>
          <Box gap="large" direction="column" grow="1" fullWidth>
            {item.role.isSystem ? (
              <Typography tag="p" variant="p-body3">
                {item.role.name}
              </Typography>
            ) : (
              <BulkActionsDrawerItemLink
                link={`/settings/role/${item.role.id}`}
                text={item.role.name}
                step={step}
                itemCategory={itemCategory}
              />
            )}

            <SpacePath spaceId={item.space.id} fallbackName={item.space.name} />
          </Box>
        </Box>

        <BulkActionsDrawerItemDismiss onDismiss={handleDismiss} />
      </Box>

      {isChooseActionStep && (
        <ActionAvailabilityBanner itemActions={actionTexts} allActionsQty={allActionsQty} />
      )}
    </BulkActionsDrawerItem>
  );
};

export default IdpGroupRolesBulkActionsSelectedItem;
